import { createQueryStringToggleHook } from "../../../stores/useQueryState";
import { useTireResults } from "../Results/useTireResults";

export const useTireCompareIds = createQueryStringToggleHook("compare", []);

export const useTireCompareIdsWithFallback: typeof useTireCompareIds = () => {
  const { data: fallback } = useTireResults();
  const [compareIds, setCompareIds] = useTireCompareIds();

  const idsWithFallback = compareIds.length
    ? compareIds
    : fallback?.allParts
        .slice(0, 3)
        .map(({ partDetails }) => partDetails.primaryPart.itemId) || [];

  return [idsWithFallback, setCompareIds];
};
